<template>
    <div id="app">
        <router-view />
        <vue-topprogress ref="topProgress"></vue-topprogress>
        <notifications group="info" position="top center" speed="700" />
    </div>
</template>

<script>
    import { vueTopprogress } from 'vue-top-progress'
    import { mapState } from 'vuex';
    export default {
        
        computed: mapState(['isLoading']),
       
        components: {
            vueTopprogress
        },
        watch: {
            isLoading(newValue) {
                if (newValue) {
                    this.$refs.topProgress.start()
                }
                else {
                    this.$refs.topProgress.done()
                }
            }
        },
       
    }
</script>